<template>
  <div>
    <v-overlay v-model="overlayProcessing"><v-progress-circular :size="100" :width="5" color="primary" indeterminate/></v-overlay>
    <UsersTable :users="this.$store.state.users" @refreshUsers="refreshUsers"/>
  </div>
</template>

<script>
import UsersRepository from '../repositories/users';
import {mapMutations} from 'vuex';
import UsersTable from "../components/UsersTable";

export default {
  name: "Users",
  components: {UsersTable},
  mounted() {
    this.init();
  },
  data() {
    return {
      overlayProcessing: false
    };
  },
  methods: {
    init() {
      if (this.$store.state.users.length === 0)
        this.refreshUsers();
    },
    ...mapMutations(['setUsers', 'setLastUpdate','setUserPagination']),
    refreshUsers(email,login) {
      this.overlayProcessing = true;
      UsersRepository.getAllUsersPaginated(this.$store.state.userPagination.currentPage - 1, this.$store.state.userPagination.size,email,login)
        .then(response => {
          if (response.status < 400) {
            this.setUsers(response.data.content);
            this.setUserPagination({
              totalPages: response.data.totalPages,
              currentPage: this.$store.state.userPagination.currentPage,
            });
            this.setLastUpdate(new Date());
            this.overlayProcessing = false;
            //alert('Users successfully updated! 😎');
          } else {
            alert('An error occurred 😅');
          }
        })
        .catch(error => {
          console.error('An error occurred', error);
          alert('An error occurred 😅');
        })
        .finally(() => {
          this.overlayProcessing = false;
        });
    },
  }
}
</script>

<style scoped>

</style>
